<script>
export default {
  props: {},
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>

<template>
  <b-nav-item-dropdown right class="mt-2">
    <template v-slot:button-content>
      <i class="fas fa-bell"></i>
    </template>
    <b-dropdown-item href="#">
      <div>
        <b-card bg-variant="info" text-variant="white">
          Order# 12331 - Processing
        </b-card>
      </div>
    </b-dropdown-item>
    <b-dropdown-item href="#">
      <div>
        <b-card bg-variant="info" text-variant="white">
          Order# 12332 - Processing
        </b-card>
      </div>
    </b-dropdown-item>
    <b-dropdown-item href="#">
      <div>
        <b-card bg-variant="primary" text-variant="white">
          Order# 12333 - Processed
        </b-card>
      </div>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<style lang="scss" module>
@import '@design';
</style>
